import { useStudio } from "@/lib/studio";

export const Logo = ({ className = "h-10" }) => (
  <img src="/logo.png" alt="Vivi Win" data-testid="app-logo" className={`${className} w-auto object-contain rounded-xl bg-white p-1`} />
);

export const NouvelleLogo = ({ className = "h-16" }) => (
  <img src="/brand/nouvelle-contest.png" alt="Nouvelle Contest" data-testid="nouvelle-logo" className={`${className} w-auto object-contain`} />
);

export const BrandFooter = ({ className = "" }) => {
  const STUDIO = useStudio();
  return (
  <footer className={`border-t border-border bg-secondary/40 py-6 px-6 ${className}`} data-testid="brand-footer">
    <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
      <div className="flex items-center gap-3">
        <NouvelleLogo className="h-10" />
        <p><span className="font-bold text-foreground">Vivi Win</span> è una soluzione <span className="font-bold text-[var(--nc-blue)]">Nouvelle Contest</span> di <span className="font-bold text-foreground">{STUDIO.name}</span></p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1" data-testid="studio-contacts">
        <a href={`tel:${STUDIO.tollFree.replace(/\s/g, "")}`} className="hover:text-foreground">Numero verde {STUDIO.tollFree}</a>
        <a href={`tel:${STUDIO.phone.replace(/\s/g, "")}`} className="hover:text-foreground">Tel. {STUDIO.phone}</a>
        <a href={`mailto:${STUDIO.email}`} className="hover:text-foreground">{STUDIO.email}</a>
        <a href={STUDIO.siteUrl} target="_blank" rel="noreferrer" className="hover:text-foreground">{STUDIO.site}</a>
        <span>{STUDIO.hours}</span>
      </div>
      <p>© {new Date().getFullYear()} Nouvelle Contest</p>
    </div>
  </footer>
  );
};

export default Logo;
